import gql from 'graphql-tag';

const DELETE_PRESENTATION_JOB = gql`
  mutation deletePresentationJob($jobId: String!, $projectId: Int!) {
    deletePresentationJob(jobId: $jobId, projectId: $projectId) {
      success
      errors
    }
  }
`;

export default DELETE_PRESENTATION_JOB;
